// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3CEmR","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2aaJc"};